/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var scrollTopAnimated_1 = require("./util/scrollTopAnimated");
var throttle_1 = require("./util/throttle");
// TODO: Use the new context API
exports.scrollContextType = PropTypes.shape({
    scrollTo: PropTypes.func,
    local: PropTypes.bool,
    pageYOffset: PropTypes.number,
    pageXOffset: PropTypes.number,
    didScrollDown: PropTypes.bool,
    didScrollRight: PropTypes.bool,
    didScrollUp: PropTypes.bool,
    didScrollLeft: PropTypes.bool
});
var ScrollPositionProvider = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollPositionProvider, _super);
    function ScrollPositionProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.handleScroll = throttle_1.throttle(_this.handleScroll.bind(_this), 20, true);
        _this.handleScrollTo = throttle_1.throttle(_this.handleScrollTo.bind(_this), 20, true);
        _this.state = _this.getScrollPosition();
        return _this;
    }
    ScrollPositionProvider.prototype.getChildContext = function () {
        return {
            scrollContext: tslib_1.__assign({}, this.state, { local: this.props.local, scrollTo: this.handleScrollTo })
        };
    };
    ScrollPositionProvider.prototype.componentDidMount = function () {
        this.installHandlers();
        if (this.state.pageYOffset !== undefined) {
            this.handleScroll();
        }
    };
    ScrollPositionProvider.prototype.componentWillUnmount = function () {
        this.uninstallHandlers();
    };
    ScrollPositionProvider.prototype.installHandlers = function () {
        this.scrollContext = this.props.local ? this.scrollNode : window;
        if (this.props.local) {
            if (this.scrollNode) {
                // @ts-ignore
                this.scrollContext = this.scrollContext.parentNode;
            }
        }
        else {
            this.scrollContext = window;
        }
        if (this.scrollContext) {
            this.scrollContext.addEventListener("scroll", this.handleScroll);
        }
    };
    ScrollPositionProvider.prototype.uninstallHandlers = function () {
        if (this.scrollContext) {
            this.scrollContext.removeEventListener("scroll", this.handleScroll);
        }
    };
    ScrollPositionProvider.prototype.handleScrollTo = function (x, y, animated) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        if (animated === void 0) { animated = false; }
        if (this.scrollContext) {
            if (animated) {
                scrollTopAnimated_1.scrollTopAnimated(this.scrollContext, x, y);
            }
            else {
                // @ts-ignore
                this.scrollContext.scrollTo(x, y);
            }
        }
    };
    ScrollPositionProvider.prototype.handleScroll = function () {
        this.setState(this.getScrollPosition());
    };
    ScrollPositionProvider.prototype.getScrollPosition = function () {
        // eslint-disable-line max-statements,complexity
        if (this.scrollContext) {
            // @ts-ignore
            var _a = this.scrollContext, pageYOffset_1 = _a.pageYOffset, pageXOffset_1 = _a.pageXOffset;
            // @ts-ignore scrollContext is of type HTMLElement here.
            if (pageYOffset_1 === undefined && this.scrollContext.document) {
                // @ts-ignore scrollContext is of type HTMLElement here.
                pageYOffset_1 = this.scrollContext.document.documentElement.pageYOffset;
                // @ts-ignore scrollContext is of type HTMLElement here.
                pageXOffset_1 = this.scrollContext.document.documentElement.pageXOffset;
            }
            if (pageYOffset_1 === undefined) {
                // @ts-ignore
                pageYOffset_1 = this.scrollContext.scrollTop;
                // @ts-ignore
                pageXOffset_1 = this.scrollContext.scrollLeft;
            }
            var didScrollDown = false;
            var didScrollRight = false;
            var didScrollUp = false;
            var didScrollLeft = false;
            if (this.state) {
                if (this.state.pageYOffset !== undefined) {
                    var deltaY = pageYOffset_1 - this.state.pageYOffset;
                    didScrollUp = deltaY < 0;
                    didScrollDown = deltaY > 0;
                }
                if (this.state.pageXOffset !== undefined) {
                    var deltaX = pageXOffset_1 - this.state.pageXOffset;
                    didScrollLeft = deltaX < 0;
                    didScrollRight = deltaX > 0;
                }
            }
            return {
                pageYOffset: pageYOffset_1,
                pageXOffset: pageXOffset_1,
                didScrollDown: didScrollDown,
                didScrollRight: didScrollRight,
                didScrollUp: didScrollUp,
                didScrollLeft: didScrollLeft
            };
        }
        return {};
    };
    ScrollPositionProvider.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        if (this.props.local) {
            return (React.createElement("div", { ref: function (scrollNode) { return (_this.scrollNode = scrollNode); } }, children));
        }
        return children;
    };
    ScrollPositionProvider.propTypes = {
        local: PropTypes.bool
    };
    ScrollPositionProvider.childContextTypes = {
        scrollContext: exports.scrollContextType
    };
    return ScrollPositionProvider;
}(React.Component));
exports.ScrollPositionProvider = ScrollPositionProvider;